import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import 'bootstrap/dist/js/bootstrap';
import 'cleave.js/dist/cleave.min.js';
import './images.js';
import 'whatwg-fetch';
import '../src/javascripts/sites.js';
import '../src/javascripts/interventions.js';
import * as ActiveStorage from "@rails/activestorage";

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// CSP-compliant per-page selector handler
document.addEventListener('turbolinks:load', function () {
  const perPageSelects = document.querySelectorAll('[data-behavior="per-page-change"]');
  perPageSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      if (this.value) {
        const url = new URL(window.location.href);
        url.searchParams.set('per_page', this.value);
        window.location = url.toString();
      }
    });
  });
});
